var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_479)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.225 14.6688L20.4094 17H29.5906L28.775 14.6688C28.6344 14.2688 28.2563 14 27.8313 14H22.1687C21.7437 14 21.3656 14.2688 21.225 14.6688V14.6688ZM18.2375 17.15L19.3375 14.0094C19.7594 12.8063 20.8937 12 22.1687 12H27.8313C29.1063 12 30.2406 12.8063 30.6625 14.0094L31.7625 17.15C32.4875 17.45 33 18.1656 33 19V23.5V25C33 25.5531 32.5531 26 32 26H31C30.4469 26 30 25.5531 30 25V23.5H20V25C20 25.5531 19.5531 26 19 26H18C17.4469 26 17 25.5531 17 25V23.5V19C17 18.1656 17.5125 17.45 18.2375 17.15ZM21 20C21 19.4469 20.5531 19 20 19C19.4469 19 19 19.4469 19 20C19 20.5531 19.4469 21 20 21C20.5531 21 21 20.5531 21 20ZM30 21C30.5531 21 31 20.5531 31 20C31 19.4469 30.5531 19 30 19C29.4469 19 29 19.4469 29 20C29 20.5531 29.4469 21 30 21Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_479",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_479"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.795ab7ee7f2e64c5df1e7b59b0cb86e1.svg";
export { ForwardRef as ReactComponent };